import { Feature } from './models/feature.model';

// Feature to Route mapping - centralized to eliminate duplication
export const FEATURE_TO_ROUTE_MAP: Record<Feature, string> = {
  [Feature.DASHBOARD]: '/dashboard',
  [Feature.TRIP]: '/tripManagement',
  [Feature.SCHEDULE_TRIP]: '/tripManagement/schedule',
  [Feature.TRACKING]: '/tracking',
  [Feature.REPORT]: '/Report/trip-report',
  [Feature.VENDOR_MANAGEMENT]: '/VenderManagement',
  [Feature.VEHICLE_MANAGEMENT]: '/VehicleManagement',
  [Feature.DRIVER_MANAGEMENT]: '/DriverManagement',
  [Feature.ROUTE_MANAGEMENT]: '/RouteManagement',
  [Feature.RATE_CARD_MANAGEMENT]: '/RateCardManagement',
  [Feature.BILLING_MANAGEMENT]: '/BillingManagement',
  [Feature.TRANSIT_MANAGEMENT]: '/transitManagement',
  [Feature.CITY_RESTRICTION]: '/transitManagement/city-restriction',
  [Feature.USER_MANAGEMENT]: '/UserManagement',
};

// Helper function to get route path for a feature
export function getFeaturePath(feature: string): string | null {
  return FEATURE_TO_ROUTE_MAP[feature as Feature] || null;
}
